import { useState } from "react";
import Logo from "../helper/svg/LOGO.svg";
import { Link, useNavigate } from "react-router-dom";
import { RiDashboardLine, RiDoorOpenLine } from "react-icons/ri";
import Ordericon from "../helper/svg/order.svg";
import RestaurantIcon from "../helper/svg/restaurant.svg";
import { CgMenuRound } from "react-icons/cg";
import ReservationIcon from "../helper/svg/Reservation.svg";
import HotelIcon from "../helper/svg/HotelIcon.svg";
import CustomerSupport from "../helper/svg/CustomerSupport.svg";
import { VscFeedback } from "react-icons/vsc";
import { LuUserCheck, LuTag, LuMegaphone, LuGift, LuUsersRound } from "react-icons/lu";
import { FiSettings } from "react-icons/fi";
import { HiMenuAlt3 } from "react-icons/hi";
import { localStorageAuthUserData } from "../helper/commanFunc";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { MdAttachMoney } from "react-icons/md";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../hooks/useTranslation";

const Sidebar = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const [isOrdersDropdownOpen, setIsOrdersDropdownOpen] = useState(false);
  const [isReservationsDropdownOpen, setIsReservationsDropdownOpen] =
    useState(false);
  const [isMenuDropdownOpen, setIsMenuDropdownOpen] = useState(false);
  const [isSubAdminDropdownOpen, setIsSubAdminDropdownOpen] = useState(false);
  const [isPromotionsDropdownOpen, setIsPromotionsDropdownOpen] =
    useState(false);
  const { role } = localStorageAuthUserData();
  const location = useLocation();
  const isActive = location.pathname;
  const { logout } = useAuth();
  const navigate = useNavigate();

  const toggleDropdown = (target) => {
    setIsOrdersDropdownOpen((prev) =>
      target === "orders" ? !prev : false
    );
    setIsReservationsDropdownOpen((prev) =>
      target === "reservations" ? !prev : false
    );
    setIsMenuDropdownOpen((prev) =>
      target === "menu" ? !prev : false
    );
    setIsSubAdminDropdownOpen((prev) =>
      target === "subAdmin" ? !prev : false
    );
    setIsPromotionsDropdownOpen((prev) =>
      target === "promotions" ? !prev : false
    );
  };

  const handleLogout = () => {
    Swal.fire({
      title: t("sidebar").logoutConfirmTitle,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("sidebar").logoutConfirmYes,
      cancelButtonText: t("sidebar").logoutConfirmNo,
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate("/");
      }
    });
  };

  return (
    <>
      <button
        className="lg:hidden fixed top-[15px] left-4 p-[6px] z-50 bg-[#4CAF50] text-white  rounded-md shadow-md "
        onClick={() => setOpen(!open)}
      >
        <HiMenuAlt3 size={20} />
      </button>

      {/* Sidebar */}
      {role === "owner" ? (
        <div
          className={`w-[300px] pt-[38px] lg:relative fixed z-20 top-0 left-0 py-[20px] px-[15px] h-screen  border-r border-[#DDDDDD] bg-[#FFFAF2] md:py-[25px] md:px-[20px] 
        ${open ? "translate-x-0" : "-translate-x-full"
            } lg:translate-x-0 lg:static `}
        >
          <div className=" flex flex-col justify-between h-full  ">
            <div className="sidebar h-max">
              {/* Logo */}
              <div className="mb-6">
                <Link to="/">
                  <img src={Logo} alt="logo" className="w-[140px]" />
                </Link>
              </div>

              {/* Nav Links */}
              <ul className="">
                <SidebarLink
                  isActive={isActive}
                  icon={<RiDashboardLine size={24} />}
                  label={t("sidebar").dashboard}
                  to="/ownerdashboard"
                />
                {/* <SidebarLink isActive={isActive}
                  icon={<img src={Ordericon} alt="Orders" />}
                  label="Orders"
                  to="/orders"
                /> */}

                <li className="border-b border-[#DDDDDD]">
                  <button
                    onClick={() => toggleDropdown("orders")}
                    className={`group flex items-center gap-[10px] w-full text-left p-[14px] text-lg font-medium cursor-pointer rounded-[2px]
    ${isOrdersDropdownOpen
                        ? "bg-[#4CAF50] text-white"
                        : "text-[#18181B] hover:bg-[#4CAF50] hover:text-white"
                      }
  `}
                  >
                    <span
                      className={`${isOrdersDropdownOpen
                        ? "text-white"
                        : "text-[#18181B] group-hover:text-white"
                        }`}
                    >
                      <img
                        src={Ordericon}
                        alt="Orders"
                        className={`w-[24px] h-[24px] ${isOrdersDropdownOpen ? "invert" : "group-hover:invert"
                          }`}
                      />
                    </span>
                    <span>{t("sidebar").orders}</span>
                    <svg
                      className={`ml-auto w-4 h-4 transition-transform  ${isOrdersDropdownOpen ? "rotate-180" : ""
                        } group-hover:stroke-white`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {isOrdersDropdownOpen && (
                    <div className="flex flex-col">
                      <Link
                        to="/hotel-orders"
                        className="p-[14px] pl-[52px] border-b border-[#DDDDDD] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group"
                      >
                        {t("sidebar").ordersForHotels}
                      </Link>
                      <Link
                        to="/orders"
                        className="p-[14px]  pl-[52px] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group "
                      >
                        {t("sidebar").ordersForRestaurants}
                      </Link>
                    </div>
                  )}
                </li>

                <SidebarLink
                  isActive={isActive}
                  icon={<img src={RestaurantIcon} alt="Restaurant" />}
                  label={t("sidebar").restaurant}
                  to="/restaurant"
                />

                <li className="border-b border-[#DDDDDD]">
                  <button
                    onClick={() => toggleDropdown("reservations")}
                    className={`group flex items-center gap-[10px] w-full text-left p-[14px] text-lg font-medium cursor-pointer rounded-[2px]
    ${isReservationsDropdownOpen
                        ? "bg-[#4CAF50] text-white"
                        : "text-[#18181B] hover:bg-[#4CAF50] hover:text-white"
                      }
  `}
                  >
                    <span
                      className={`${isReservationsDropdownOpen
                        ? "text-white"
                        : "text-[#18181B] group-hover:text-white"
                        }`}
                    >
                      <img
                        src={ReservationIcon}
                        alt="Reservations"
                        className={`w-[24px] h-[24px] ${isReservationsDropdownOpen
                          ? "invert"
                          : "group-hover:invert"
                          }`}
                      />
                    </span>
                    <span>{t("sidebar").reservations}</span>
                    <svg
                      className={`ml-auto w-4 h-4 transition-transform  ${isReservationsDropdownOpen ? "rotate-180" : ""
                        } group-hover:stroke-white`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {isReservationsDropdownOpen && (
                    <div className="flex flex-col">
                      <Link
                        to="/reservationforhotels"
                        className="p-[14px] pl-[52px] border-b border-[#DDDDDD] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group"
                      >
                        {t("sidebar").reservationForHotel}
                      </Link>
                      <Link
                        to="/reservationforrestaurants"
                        className="p-[14px]  pl-[52px] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group "
                      >
                        {t("sidebar").reservationForRestaurant}
                      </Link>
                    </div>
                  )}
                </li>

                <li className="border-b border-[#DDDDDD]">
                  <button
                    onClick={() => toggleDropdown("menu")}
                    className={`group flex items-center gap-[10px] w-full text-left p-[14px] text-lg font-medium cursor-pointer rounded-[2px]
    ${isMenuDropdownOpen
                        ? "bg-[#4CAF50] text-white"
                        : "text-[#18181B] hover:bg-[#4CAF50] hover:text-white"
                      }
  `}
                  >
                    <span
                      className={`${isMenuDropdownOpen
                        ? "text-white"
                        : "text-[#18181B] group-hover:text-white"
                        }`}
                    >
                      {/* <img
                        src={ReservationIcon}
                        alt="Reservations"
                        className={`w-[24px] h-[24px] ${isReservationsDropdownOpen
                          ? "invert"
                          : "group-hover:invert"
                          }`}
                      /> */}
                      <CgMenuRound size={24} />
                    </span>
                    <span>{t("sidebar").menuManagement}</span>
                    <svg
                      className={`ml-auto w-4 h-4 transition-transform  ${isMenuDropdownOpen ? "rotate-180" : ""
                        } group-hover:stroke-white`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {isMenuDropdownOpen && (
                    <div className="flex flex-col">
                      <Link
                        to="/addhotelmenu"
                        className="p-[14px] pl-[52px] border-b border-[#DDDDDD] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group"
                      >
                        {t("sidebar").menuForHotel}
                      </Link>
                      <Link
                        to="/addrestaurantmenu"
                        className="p-[14px]  pl-[52px] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group "
                      >
                        {t("sidebar").menuForRestaurant}
                      </Link>
                    </div>
                  )}
                </li>

                {/*  <SidebarLink isActive={isActive}
                  icon={<CgMenuRound size={24} />}
                  label="Menu Management"
                  to="/addrestaurantmenu"
                /> */}
                <SidebarLink
                  isActive={isActive}
                  icon={<img src={HotelIcon} alt="Hotel" />}
                  label={t("sidebar").addNewHotel}
                  to="/addnewhotel"
                />
                <SidebarLink
                  isActive={isActive}
                  icon={<RiDoorOpenLine size={24} />}
                  label={t("sidebar").roomListings}
                  to="/roomlisting"
                />
                <SidebarLink
                  isActive={isActive}
                  icon={<img src={CustomerSupport} alt="Support" />}
                  label={t("sidebar").customerSupport}
                  to="/customersupport"
                />
                <SidebarLink
                  isActive={isActive}
                  icon={<VscFeedback size={24} />}
                  label={t("sidebar").reviewsFeedback}
                  to="/reviewandfeedback"
                />
                {/*  <SidebarLink isActive={isActive}
                icon={<LuUserCheck size={24} />}
                label="Sub-Admin roles"
                to="#"
              /> */}
                <li className="border-b border-[#DDDDDD]">
                  <button
                    onClick={() => toggleDropdown("subAdmin")}
                    className={`group flex items-center gap-[10px] w-full text-left p-[14px] text-lg font-medium cursor-pointer rounded-[2px]
    ${isSubAdminDropdownOpen
                        ? "bg-[#4CAF50] text-white"
                        : "text-[#18181B] hover:bg-[#4CAF50] hover:text-white"
                      }
  `}
                  >
                    <span
                      className={`${isSubAdminDropdownOpen
                        ? "text-white"
                        : "text-[#18181B] group-hover:text-white"
                        }`}
                    >
                      <LuUserCheck size={24} />
                    </span>
                    <span>{t("sidebar").subAdminRoles}</span>
                    <svg
                      className={`ml-auto w-4 h-4 transition-transform  ${isSubAdminDropdownOpen ? "rotate-180" : ""
                        } group-hover:stroke-white`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {isSubAdminDropdownOpen && (
                    <div className="flex flex-col">
                      <Link
                        to="/managehotels"
                        className="p-[14px] pl-[52px] border-b border-[#DDDDDD] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group"
                      >
                        {t("sidebar").manageHotel}
                      </Link>
                      <Link
                        to="/managerestaurants"
                        className="p-[14px]  pl-[52px] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group "
                      >
                        {t("sidebar").manageRestaurant}
                      </Link>
                    </div>
                  )}
                </li>

                <li className="border-b border-[#DDDDDD]">
                  <button
                    onClick={() => toggleDropdown("promotions")}
                    className={`group flex items-center gap-[10px] w-full text-left p-[14px] text-lg font-medium cursor-pointer rounded-[2px]
    ${isPromotionsDropdownOpen
                        ? "bg-[#4CAF50] text-white"
                        : "text-[#18181B] hover:bg-[#4CAF50] hover:text-white"
                      }
  `}
                  >
                    <span
                      className={`${isPromotionsDropdownOpen
                        ? "text-white"
                        : "text-[#18181B] group-hover:text-white"
                        }`}
                    >
                      <LuTag size={24} />
                    </span>
                    <span>{t("sidebar").promotions}</span>
                    <svg
                      className={`ml-auto w-4 h-4 transition-transform  ${isPromotionsDropdownOpen ? "rotate-180" : ""
                        } group-hover:stroke-white`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {isPromotionsDropdownOpen && (
                    <div className="flex flex-col">
                      <Link
                        to="/hoteloffers"
                        className="p-[14px] pl-[52px] border-b border-[#DDDDDD] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group"
                      >
                        {t("sidebar").hotelOffers}
                      </Link>
                      <Link
                        to="/restaurantoffers"
                        className="p-[14px]  pl-[52px] text-[#18181B] text-lg font-medium cursor-pointer  hover:text-[#4CAF50] hover:rounded-[2px] group "
                      >
                        {t("sidebar").restaurantOffers}
                      </Link>
                    </div>
                  )}
                </li>
                <SidebarLink
                  isActive={isActive}
                  icon={<FiSettings size={24} />}
                  label={t("sidebar").settings}
                  to="/settingsusers"
                />
              </ul>
            </div>

            {/* Logout */}
            <div className="">
              <button
                onClick={handleLogout}
                className="inline-block w-full  rounded-[2px] bg-[#4CAF50] 2xl:text-[20px]  text-base text-white text-center font-bold 2xl:p-[14px] p-3 green-shadow hover:bg-[#209b25]"
              >
                {t("sidebar").logout}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`w-[300px] pt-[38px] lg:relative fixed z-20 top-0 left-0 py-[20px] px-[15px] h-screen  border-r border-[#DDDDDD] bg-[#FFFAF2] md:py-[25px] md:px-[20px] 
        ${open ? "translate-x-0" : "-translate-x-full"
            } lg:translate-x-0 lg:static `}
        >
          <div className=" flex flex-col justify-between h-full  ">
            <div className="sidebar h-max">
              {/* Logo */}
              <div className="mb-6">
                <Link to="/">
                  <img src={Logo} alt="logo" className="w-[140px]" />
                </Link>

              </div>

              {/* Nav Links */}
              <ul className="">
                <SidebarLink
                  isActive={isActive}
                  icon={<RiDashboardLine size={24} />}
                  label={t("sidebar").dashboard}
                  to="/admindashboard"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<img src={RestaurantIcon} alt="Restaurant" />}
                  label={t("sidebar").restaurantManagement}
                  to="/restaurantmanagement"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<img src={HotelIcon} alt="Hotel" />}
                  label={t("sidebar").hotelManagement}
                  to="/hotelmanagement"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<LuUsersRound size={24} />}
                  label={t("sidebar").userManagement}
                  to="/usermanagement"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<MdAttachMoney size={24} />}
                  label={t("sidebar").commissions}
                  to="/commissions"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                  </svg>}
                  label={t('languageManagement').title}
                  to="/language-management"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<LuGift size={24} />}
                  label={t("referralManagement").title}
                  to="/referral-management"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<LuUserCheck size={24} />}
                  label={t("sidebar").subAdminRoles}
                  to="adminsubadminroles"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<img src={CustomerSupport} alt="Support" />}
                  label={t("sidebar").support}
                  to="/support"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<LuTag size={24} />}
                  label={t("sidebar").Offers}
                  to="/promotionslist"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<LuMegaphone size={24} />}
                  label={t("sidebar").promotions}
                  to="/sponsored"
                />

                <SidebarLink
                  isActive={isActive}
                  icon={<FiSettings size={24} />}
                  label={t("sidebar").settings}
                  to="/adminsettings"
                />
              </ul>
            </div>

            {/* Logout */}
            <div className="">
              <button
                onClick={handleLogout}
                className="inline-block w-full  rounded-[2px] bg-[#4CAF50] 2xl:text-[20px]  text-base text-white text-center font-bold 2xl:p-[14px] p-3 green-shadow hover:bg-[#209b25]"
              >
                {t("sidebar").logout}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Reusable Link Component
const SidebarLink = ({ icon, label, to, isActive }) => (
  <li>
    <Link
      to={to}
      className={`flex items-center gap-[10px] p-[14px] border-b border-[#DDDDDD] text-lg font-medium cursor-pointer rounded-[2px] group
          ${isActive === to
          ? "bg-[#4CAF50] text-white"
          : "text-[#18181B] hover:bg-[#4CAF50] hover:text-white"
        }
        `}
    >
      <span
        className={`${isActive === to
          ? "text-white"
          : "text-[#18181B] group-hover:text-white"
          }`}
      >
        {icon}
      </span>
      {label}
    </Link>
  </li>
);

export default Sidebar;
